'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _FormFieldSpinnerUp = require('wix-ui-icons-common/system/FormFieldSpinnerUp');

var _FormFieldSpinnerUp2 = _interopRequireDefault(_FormFieldSpinnerUp);

var _FormFieldSpinnerDown = require('wix-ui-icons-common/system/FormFieldSpinnerDown');

var _FormFieldSpinnerDown2 = _interopRequireDefault(_FormFieldSpinnerDown);

var _Ticker = require('./Ticker.scss');

var _Ticker2 = _interopRequireDefault(_Ticker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Ticker = function Ticker(_ref) {
  var onUp = _ref.onUp,
      onDown = _ref.onDown,
      upDisabled = _ref.upDisabled,
      downDisabled = _ref.downDisabled;
  return _react2.default.createElement(
    'div',
    { className: _Ticker2.default.root, 'data-hook': 'ticker' },
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames4.default)(_Ticker2.default.up, _defineProperty({}, _Ticker2.default.disabled, upDisabled)),
        onClick: upDisabled ? null : onUp
      },
      _react2.default.createElement(_FormFieldSpinnerUp2.default, null)
    ),
    _react2.default.createElement(
      'div',
      {
        className: (0, _classnames4.default)(_Ticker2.default.down, _defineProperty({}, _Ticker2.default.disabled, downDisabled)),
        onClick: downDisabled ? null : onDown
      },
      _react2.default.createElement(_FormFieldSpinnerDown2.default, null)
    )
  );
};

Ticker.displayName = 'Input.Ticker';

Ticker.propTypes = {
  onUp: _propTypes2.default.func,
  onDown: _propTypes2.default.func,
  upDisabled: _propTypes2.default.bool,
  downDisabled: _propTypes2.default.bool
};

exports.default = Ticker;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Input/Ticker/Ticker.js
// module id = 1333
// module chunks = 0